/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
//import LazyLoad from 'vanilla-lazyload';
import ChangeClassOnH1 from './Classes/ChangeClassOnH1';
import ChartToggler from './Classes/ChartToggler';
import CountUpNumbers from './Classes/countUpNumbers';
import ScrollToSection from './Classes/ScrollToSection';
import Header from './Classes/Header';
import FrontpageSideNav from './Classes/FrontpageSideNav';
import SidebarScrollsWhenFooterInView from './Classes/SidebarScrollsWhenFooterInView';
import BackToTop from './Classes/BackToTop';
import AnimationsOnScroll from './Classes/AnimationsOnScroll';
import Map from './Classes/Map';
import LinkHandler from './Classes/LinkHandler';
import IeNotification from './Classes/IeNotification';
import Video from './Classes/Video';
//import ResponsiveTable from "./Classes/ResponsiveTable";
//import XDownloader from "./Classes/XDownloader";

import Accordion from './Classes/Accordion';
import SliderHandler from './Classes/SliderHandler';
import SVGAnimation from './Classes/SVGAnimation';
import DynamicChartToggler from './Classes/DynamicChartToggler';
// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';
// import YoutubeLinks from './Classes/YoutubeLinks';

var focusHandlerInstance = null;
//var lazyLoadInstance = null;
var responsiveTableInstance = null;
var downloaderInstance = null;
var changeClassOnH1 = null;
var chartToggler = null;
var countUpNumbers = null;
var scrollToSection = null;
var header = null;
var frontpageSideNav = null;
var sidebarScrollsWhenFooterInView = null;
var backToTop = null;
var animationsOnScroll = null;
var svgAnimation = null;
var map = null;
var linkhandler = null;
var linkhandler2 = null;
var ieNotification = null;
var videoInstance = null;

var sliderInstance = null;

var accordionInstance = null;
//var jumpInstance = null;
//var youtubeLinksInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  // lazyload: (givenNodeset) => {
  //   lazyLoadInstance.update(givenNodeset);
  // }

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  ieNotification = new IeNotification();

  focusHandlerInstance = new FocusHandler();

  //lazyLoadInstance = new LazyLoad();

  videoInstance = new Video({
    video: '.ns-video__thumbnail'
  });

  changeClassOnH1 = new ChangeClassOnH1({
    button: '.ns-title-h1-front__btn',
    container: '.ns-title-h1-front'
  });

  sliderInstance = new SliderHandler({
    outerWrapperSelector: '.ns-tiles__item'
  });

  const videoSliderInstance = new SliderHandler({
    outerWrapperSelector: '.ns-video-slider'
  });

  chartToggler = new ChartToggler({
    buttons: '.ns-graphic__button',
    charts: '.ns-graphic__wrapper-outer',
    chartContainer: '.ns-graphic--with-option:not(.ns-graphic-toggle-container)'
  });

  new DynamicChartToggler({
    container: '.ns-graphic-toggle-container',
    checkbox: '.ns-graphic__button',
    charts: '.ns-graphic__wrapper-outer'
  });

  countUpNumbers = new CountUpNumbers({
    numbers: '.ns-keyfigures__item__number--ani',
    classIn: 'is-in-viewport',
    classOut: 'is-not-in-viewport',
    langArray: ['de-DE', 'en-US', 'fr-FR'],
    decimalArray: [',', '.', ','],
    thousandSepArray: [' ',' ', ' '],
    thousandSepArray2: [' ',' ', ' '], //thin space
    thousandSepArray3: ['\u00A0','\u00A0', '\u00A0'] //non breaking space
  });


  frontpageSideNav = new FrontpageSideNav({
    navItem: '.not-visible .menu__item--level-1',
    parent: '.header__between'
  });

  scrollToSection = new ScrollToSection({});

  accordionInstance = new Accordion({
    button: '.js-toggle-accordion',
    accordionsClass: '.ns-accordion'
  });


  header = new Header({
    submenuTogglerSelector: '.menu--main .menu__item--has-children .menu__link--level-0',
    submenuLinkSelector: '.menu__link--level-1',
    menuTogglerSelector: '.js-menu-toggle',
    menuContainerSelector: '.header',
    breakPointLg: 1025
  });

  sidebarScrollsWhenFooterInView = new SidebarScrollsWhenFooterInView({
    sidebar: '.header__between',
    footer: '.footer',
    header: '.header',
    breakPointLg: 1025,
    breakPointMd: 768,
    breakPointSm: 480
  });

  backToTop = new BackToTop();

  animationsOnScroll = new AnimationsOnScroll({});

  svgAnimation = new SVGAnimation({});

  map = new Map();

  linkhandler = new LinkHandler({
    linkClass: '.js-target-blank'
  });

  linkhandler2 = new LinkHandler({
    linkClass: '.ns-link__download'
  });

  /* responsiveTableInstance = new ResponsiveTable({
    tableSelector: '.ns-table-wrap table',
    tableWrapperSelector: '.ns-table-wrap',
    breakPointLg: 1200,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 3,
    colCountEarlyBreak: 7,
    noSplitArray: []
  }); */

  /* downloaderInstance = new XDownloader({
    downloadText: "Download Excel", //Can be empty if you want to use an icon instead
    backgroundColor: "6ab04c", //Colored Cells Background
    backgroundClass: 'ns-backgroundcolor-gf_3a-green', //Class of colored cells
    borderColor: '95afc0', //Color of border
    borderStyle: 'thin', // thin/dotted/medium/double/thick
    headClass: 'head', //Class you want your columns based on. Will be bold in Excel
    boldClass: 'title', //Class for Bold text in Excel
    borderClass: 'ns-borderbottom-line_dots'
  }); */

  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

});
